<template>
  <div class="sign-in-form">
    <form @submit.prevent="submit">
      <h1>{{ $t("signInConnectedAccountPage.title") }}</h1>
      <div class="description">
        {{ $t("signInConnectedAccountPage.description") }}
      </div>
      <text-field class="input" type="email" :label="$t('signInConnectedAccountPage.emailLabel')" v-model="email" />
      <text-field
        class="input"
        type="password"
        :label="$t('signInConnectedAccountPage.passwordLabel')"
        v-model="password"
      />
      <div class="attention">{{ $t("signInConnectedAccountPage.passwordRequirement") }}</div>
      <div class="sign-in-container">
        <p class="sign-in-txt">
          {{ $t("signInConnectedAccountPage.agreementText") }}
          <a href="/terms" target="_blank">{{ $t("signInConnectedAccountPage.termsOfService") }}</a
          >{{ $t("signInConnectedAccountPage.and")
          }}<a href="/privacy" target="_blank">{{ $t("signInConnectedAccountPage.privacyPolicy") }}</a
          >{{ $t("signInConnectedAccountPage.agreementTextSuffix") }}
        </p>
        <button-default class="login-button">{{ $t("signInConnectedAccountPage.loginButton") }}</button-default>
      </div>
    </form>
    <div v-if="message" v-html="message"></div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import TextField from "@/components/molecules/TextField.vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";
import { Auth } from "aws-amplify";
import { Tutorial } from "@/lib/models/tutorial";
import { createHomeIntroSlidesTutorial } from "@/lib/utils/tutorial";

export default Vue.extend({
  components: { ButtonDefault, TextField },
  props: {
    propEmail: { type: String, default: "" },
  },
  data() {
    return {
      email: this.propEmail,
      password: "",
      message: "",
    };
  },
  methods: {
    async submit() {
      const { email, password, $store } = this;

      try {
        const res = await Auth.signIn(email, password);
        if (res.challengeName === "NEW_PASSWORD_REQUIRED") {
          this.$router.push({ name: "newPassword" });
        } else if (res) {
          // Nolaの利用が初めてか確認
          await $store.dispatch("novelModule/initialize");
          const novels = await $store.getters["novelModule/novels"];
          if (novels.length === 0) {
            // はじめてのNolaのデータとチュートリアルデータを作成
            const tutorial: Tutorial = {
              screen: "home",
              category: "first",
              step: "before",
            };
            await Promise.all([
              $store.dispatch("generalModule/createSampleData"),
              $store.dispatch("tutorialModule/createTutorial", { tutorial }),
              createHomeIntroSlidesTutorial($store),
            ]);
          }

          this.$router.push({ name: "home" });
          // eslint-disable-next-line no-throw-literal
        } else throw "error";
      } catch (err: unknown) {
        const code = err && typeof err === "object" && "code" in err ? (err as { code: string }).code : null;
        if (code === "UserNotConfirmedException") {
          this.$router.push({
            name: "resendConfirmCode",
            params: {
              propEmail: email,
              propMessage: this.$t("signInConnectedAccountPage.validation.confirmCodeNotEntered") as string,
            },
          });
        } else if (code === "LimitExceededException") {
          this.message = this.$t("signInConnectedAccountPage.validation.limitExceeded") as string;
        } else {
          this.message = this.$t("signInConnectedAccountPage.validation.invalidCredentials") as string;
        }
        setTimeout(() => {
          this.message = "";
        }, 3000);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

h1 {
  font-size: var(--font-size-lg);
  border-bottom: 1px solid var(--color-border);
  text-align: center;
  color: var(--color-text-normal);
}

.attention {
  font-size: var(--font-size-xs);
  color: var(--color-text-low);
}

.input {
  margin-bottom: 15px;
}

.description {
  margin-bottom: 15px;
  color: var(--color-text-normal);
}

.sign-in-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .sign-in-txt {
    color: var(--color-text-normal);
    margin: 30px;
    margin-bottom: 10px;

    @include mq(sp) {
      font-size: var(--font-size-xs);
    }

    a {
      font-weight: var(--font-weight-bold);
      text-decoration: none;
      color: var(--color-primary);
    }
  }

  .login-button {
    padding: 12px 50px;
    border-radius: var(--radius-rounded);
    background-color: var(--color-primary);
    border-color: var(--color-primary);
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    color: var(--color-text-on-fixed-bg);
    cursor: pointer;
  }
}
</style>
